'use strict';

const Backbone = require('backbone');
const Actions = require('common/domain/action/index');
const Dispatcher = require('common/domain/repository/dispatcher');
const TagApi = require('system/infra/api/tag');

const TagActionCreator = Backbone.Model.extend({
    initialize: function() {
        this._fetched = {};
    },

    fetchTags: function(projectId) {
        return new Promise((resolve, reject) => {
            const tagP = TagApi.getTags(projectId);
            const categoryP = TagApi.getTagCategories(projectId);
            Promise.all([tagP, categoryP])
                .then(values => {
                    const tags = values[0];
                    const categories = values[1];
                    const context = {
                        projectId: projectId
                    };

                    Dispatcher.dispatch({
                        type: Actions.CREATE_TAG_CATEGORY,
                        context: context,
                        category: categories,
                        options: {fetched: true}
                    });
                    Dispatcher.dispatch({
                        type: Actions.CREATE_TAG,
                        context: context,
                        tag: tags,
                        options: {fetched: true}
                    });
                    resolve();
                }, reject);
        });
    },

    fetchTagsOnce: function(projectId) {
        const key = projectId;
        let promise = this._fetched[key];
        if(!promise) {
            promise = this.fetchTags(projectId);
            this._fetched[key] = promise;
        }
        return promise;
    },

    createTag: function(projectId, tagId, tagJson) {
        return new Promise((resolve, reject) => {
            TagApi.createTag(projectId, tagId, tagJson)
                .then(tag => {
                    Dispatcher.dispatch({
                        type: Actions.CREATE_TAG,
                        context: {
                            projectId: projectId
                        },
                        tag: tag
                    });
                    resolve(tag);
                }, reject);
        });
    },

    updateTag: function(projectId, tagId, tagJson) {
        return new Promise((resolve, reject) => {
            TagApi.updateTag(projectId, tagId, tagJson)
                .then(tag => {
                    Dispatcher.dispatch({
                        type: Actions.UPDATE_TAG,
                        context: {
                            projectId: projectId
                        },
                        tag: tag
                    });
                    resolve(tag);
                }, reject);
        });
    },

    deleteTag: function(projectId, tagId) {
        return new Promise((resolve, reject) => {
            TagApi.deleteTag(projectId, tagId)
                .then(tag => {
                    Dispatcher.dispatch({
                        type: Actions.DELETE_TAG,
                        context: {
                            projectId: projectId
                        },
                        tag: tag
                    });
                    resolve(tag);
                }, reject);
        });
    },

    toggleTag: function(params) {
        Dispatcher.dispatch({
            type: Actions.TOGGLE_TAG,
            context: params.context,
            tag: params.tag
        });
    },

    categorizeTag: function(projectId, tagId, categoryId) {
        const context = {
            projectId: projectId
        };
        Dispatcher.dispatch({
            type: Actions.CATEGORIZE_TAG,
            context: context,
            tag: {
                id: tagId
            },
            category: {
                id: categoryId
            }
        });
        return new Promise((resolve, reject) => {
            TagApi.updateTag(projectId, tagId, {
                category: categoryId ? categoryId : null
            })
                .then(tag => {
                    resolve(tag);
                }, reject);
        });
    },

    createCategory: function(projectId, categoryId, tagJson) {
        return new Promise((resolve, reject) => {
            TagApi.createTagCategory(projectId, categoryId, tagJson)
                .then(category => {
                    Dispatcher.dispatch({
                        type: Actions.CREATE_TAG_CATEGORY,
                        context: {
                            projectId: projectId
                        },
                        category: category
                    });
                    resolve(category);
                }, reject);
        });
    },

    updateCategory: function(projectId, categoryId, categoryJson) {
        return new Promise((resolve, reject) => {
            TagApi.updateTagCategory(projectId, categoryId, categoryJson)
                .then(category => {
                    Dispatcher.dispatch({
                        type: Actions.UPDATE_TAG_CATEGORY,
                        context: {
                            projectId: projectId
                        },
                        category: category
                    });
                    resolve(category);
                }, reject);
        });
    },

    deleteCategory: function(projectId, categoryId) {
        return new Promise((resolve, reject) => {
            TagApi.deleteTagCategory(projectId, categoryId)
                .then(category => {
                    Dispatcher.dispatch({
                        type: Actions.DELETE_TAG,
                        context: {
                            projectId: projectId
                        },
                        category: category
                    });
                    resolve(category);
                }, reject);
        });
    },

    toggleCategory: function(params) {
        this._app.Dispatcher.dispatch({
            type: Actions.TOGGLE_TAG_CATEGORY,
            context: params.context,
            category: params.category
        });
    }
});

module.exports = new TagActionCreator();



// WEBPACK FOOTER //
// ./system/domain/action/tag.js